import React from 'react';
import styles from './styles.pcss';

interface ActionsComponentProps {
  selectedIds: number[];
  onActionClick: (selectedIds: number[]) => void;
  label: string;
  color?: string
}

const ActionsComponent: React.FC<ActionsComponentProps & { isDisabled?: boolean }> = ({ selectedIds, onActionClick, label, color, isDisabled }) => {
  const handleActionClick = () => {
    if (!isDisabled) {
      onActionClick(selectedIds);
    }
  };

  return (
    <div className={styles.actionButtonsContainer}>
      {color === 'red' ? (
        <div
          className={`${styles.actionButtonRed} ${isDisabled ? styles.actionButtonDisabled : ''}`}
          onClick={isDisabled ? undefined : handleActionClick}
        >
          {label}
        </div>
      ) : (
        <div
          className={`${styles.actionButtonBlue} ${isDisabled ? styles.actionButtonDisabled : ''}`}
          onClick={isDisabled ? undefined : handleActionClick}
        >
          {label}
        </div>
      )}
    </div>
  );
};

export default ActionsComponent;
